import { Component, OnInit } from '@angular/core';
import { StoresService } from '../../shared/stores.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { LocationService } from '../../shared/location.service';
import { Location } from '../../shared/location.model';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit {

  locations: Location[];

  constructor(private service : StoresService,
    private locationService: LocationService,
    private firestore : AngularFirestore,
    private toastr :ToastrService) { }

  ngOnInit() {
    this.resetForm();
    this.locationService.getLocations().subscribe(actionArray => {
      this.locations = actionArray.map(item => {
        const data = item.payload.doc.data() as Location;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });
  }
  
  resetForm(form? : NgForm){
    if(form != null)
      form.resetForm();
    this.service.storeData = {
      id : null,
      name : '',
      order : '',
      location : '',
      message : '',
      open : false,
      status : '',
      timing : ''
      
    }
  }

  onSubmit(form:NgForm){
    let data = Object.assign({}, form.value)
    delete data.id;
    if(form.value.id == null)
      this.firestore.collection('stores').add(data);
    else
      this.firestore.doc('stores/' + form.value.id).update(data)
    this.resetForm(form);
    this.toastr.success('Submitted Successfully','stores')
  }

}
